//console.log("✅ cart-upsell.js loaded");

const selectedDate = sessionStorage.getItem("selectedExperienceDate");
const selectedTime = sessionStorage.getItem("selectedExperienceTimeOnly");

if (selectedDate && selectedTime) {
  console.log("➡️ Match experience for:", selectedDate, selectedTime);
}
 
// === CONFIGURATION: Set which days allow upsell ===
const upsellDays = ["Saturday"]; // Add more like ["Friday", "Saturday", "Sunday"]

async function showExperienceUpsell() {
  const response = await fetch("/cart.js");
  const cart = await response.json();

  let hasTasting = false;
  let hasTour = false;
  let tastingDate = "";
  let tastingTime = "";
  let tourDate = "";
  let tourTime = "";

  cart.items.forEach((item) => {
    const title = item.title.toLowerCase();
    const productTitle = item.product_title?.toLowerCase() || "";
    const type = item.product_type?.toLowerCase() || "";

    if (
      title.includes("tasting") ||
      productTitle.includes("tasting") ||
      type.includes("tasting") ||
      item.handle?.toLowerCase().includes("tasting")
    ) {
      hasTasting = true;
      tastingDate = sessionStorage.getItem("selectedExperienceDate") || extractDate(item);
      tastingTime = sessionStorage.getItem("selectedExperienceTimeOnly") || extractTime(item);
      sessionStorage.setItem("ticketType", "tasting");
    }

    if (
      title.includes("tour") ||
      productTitle.includes("tour") ||
      type.includes("tour") ||
      item.handle?.toLowerCase().includes("tour")
    ) {
      hasTour = true;
      tourDate = sessionStorage.getItem("selectedExperienceDate") || extractDate(item);
      tourTime = sessionStorage.getItem("selectedExperienceTimeOnly") || extractTime(item);
      sessionStorage.setItem("ticketType", "tour");
    }
  });
const experienceDate = tastingDate || tourDate;
const decodedExperienceDate = decodeURIComponent(experienceDate);
const parsedExperienceDate = new Date(decodedExperienceDate);

const startDate = new Date("2025-10-04"); // Set your real start threshold
const dayOfWeek = parsedExperienceDate.toLocaleDateString("en-US", { weekday: "long" });

console.log("📅 Experience date is on:", dayOfWeek);

if (!upsellDays.includes(dayOfWeek)) {
  console.log("❌ No upsell – not an eligible day.");
  return;
}

let upsellHtml = "";

if (parsedExperienceDate > startDate) {


  if (hasTasting && !hasTour) {
    upsellHtml = `
      <div class="cart-upsell">
        <h2 style="font-size: 2em;"><strong>Want a tour after your tasting?</strong></h2>
        <h2 style="margin: 15px 0px; font-size: 1.6em; padding-bottom: 5px; border-bottom: 1px solid; width: auto;">
          <a href="/products/barrel-aged-legacy-tour-with-barrel-sample?date=${tastingDate}">
            Add a Tour
          </a>
        </h2>
        <p class="small text-muted">
          Pick a tour for after your tasting.
        </p>
      </div>
    `;
  } else if (hasTour && !hasTasting) {
    upsellHtml = `
      <div class="cart-upsell">
        <h2 style="font-size: 2em;"><strong>Start with a tasting?</strong></h2>
        <h2 style="margin: 15px 0px; font-size: 1.6em; padding-bottom: 5px; border-bottom: 1px solid; width: auto;">
          <a href="/products/heritage-tasting-experience?date=${tourDate}">
            Add a Tasting
          </a>
        </h2>
        <p class="small text-muted">
          Choose a tasting that starts before your tour.
        </p>
      </div>
    `;
  }

}
  if (upsellHtml) {
    const cartForm = document.querySelector('form[action="/cart"]');
    if (cartForm) {
      const upsellEl = document.createElement("div");
      upsellEl.innerHTML = upsellHtml;
      cartForm.appendChild(upsellEl);
    }
  }
}

function extractDate(item) {
  if (item.properties?.When) {
    const raw = item.properties.When.split("to")[0].trim();
    const match = raw.match(/[A-Za-z]{3,9} \d{1,2}, \d{4}/); // e.g., "Oct 4, 2025"
    return match ? encodeURIComponent(match[0]) : "";
  }
  return "";
}

function extractTime(item) {
  if (item.properties?.When) {
    const raw = item.properties.When.split("to")[0].trim();
    const match = raw.match(/\d{1,2}:\d{2} ?(am|pm)/i); // e.g., "2:00pm"
    return match ? match[0] : "";
  }
  return "";
}

function getDayOfWeek(dateStr) {
  try {
    const decoded = decodeURIComponent(dateStr);
    const parsedDate = new Date(decoded);
    const options = { weekday: "long" };
    return parsedDate.toLocaleDateString("en-US", options); // e.g., "Saturday"
  } catch (e) {
    console.warn("⚠️ Unable to parse date:", dateStr);
    return "";
  }
}

document.addEventListener("DOMContentLoaded", showExperienceUpsell);